import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate('/', { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        const exchange = async () => {
            try {
                const res = await axios.post(
                    `${API}/auth/google/callback`,
                    { session_id: sessionId },
                    { withCredentials: true }
                );
                setUser(res.data);
                navigate('/', { replace: true });
            } catch (error) {
                console.error('Auth callback failed:', error);
                navigate('/', { replace: true });
            }
        };
        exchange();
    }, [navigate, setUser]);

    return (
        <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            minHeight: '100vh', backgroundColor: '#0B1235', color: '#C9952A',
            fontFamily: "'Lato', sans-serif", fontSize: '18px'
        }}>
            Signing you in...
        </div>
    );
}
